export default () => {
  const ckbox = document.querySelector('.checkbox-field__input');
  ckbox && ckbox.focus();
};
